export default __webpack_public_path__ + "barion-card-strip-intl__small.webp";